import * as React from "react";
import type { SizeDetailState } from "../useSizeDetail";

export function useSpecificationDimension(infoDetail: SizeDetailState) {
  return React.useMemo(() => {
    const rawDimension = infoDetail?.dimension;
    const dimensionTrim =
      rawDimension != null ? String(rawDimension).trim() : "";
    if (
      dimensionTrim &&
      dimensionTrim.toLowerCase() !== "undefined" &&
      dimensionTrim.toLowerCase() !== "null"
    ) {
      return dimensionTrim;
    }
    const w = Number((infoDetail as any)?.width) || 0;
    const h = Number((infoDetail as any)?.height) || 0;
    return `${w}"w x ${h}"h`;
  }, [infoDetail]);
}
